import AlertHistory from "./AlertHistory";

export default AlertHistory;